module.exports = __webpack_public_path__ + "img/livechat-orange.e162916d.svg";